import { render, staticRenderFns } from "./OctMedia.vue?vue&type=template&id=4d4394b1&scoped=true&"
import script from "./OctMedia.vue?vue&type=script&lang=js&"
export * from "./OctMedia.vue?vue&type=script&lang=js&"
import style0 from "./OctMedia.vue?vue&type=style&index=0&id=4d4394b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4394b1",
  null
  
)

export default component.exports